<template>
  <div class="mt-6 container has-text-centered">
    <div class="column is-4 is-offset-4">
      <img src="/img/main-logo.svg" />
      <hr class="login-hr" />
      <p class="subtitle has-text-black">{{ $t("auth.signinMessage") }}</p>
      <FlashMessage color="is-info"></FlashMessage>
      <div class="box has-text-left">
        <form @submit.prevent="signIn">
          <div class="field">
            <label class="label">{{ $t("Space") }} *</label>
            <div class="control">
              <input
                class="input"
                type="text"
                placeholder="Your Space"
                required
                autofocus=""
                v-model="form.space"
              />
            </div>
          </div>

          <div class="field">
            <label class="label">{{ $t("Email") }} *</label>
            <div class="control">
              <input
                class="input"
                type="email"
                placeholder="Your Email"
                required
                autofocus=""
                v-model="form.email"
              />
            </div>
          </div>

          <div class="field">
            <label class="label">{{ $t("Password") }} *</label>
            <div class="control">
              <input
                class="input"
                type="password"
                placeholder="Your Password"
                required
                v-model="form.password"
              />
            </div>
          </div>

          <div class="field" v-if="isCode">
            <label class="label">{{ $t("auth.userCode") }} *</label>
            <div class="control">
              <input
                class="input"
                type="text"
                placeholder="Code"
                required
                autofocus=""
                maxlength="6"
                v-model="form.userCode"
              />
            </div>
          </div>

          <button
            class="button is-block is-primary is-large is-fullwidth"
            v-bind:class="{ 'is-loading': isLoad }"
          >
            {{ $t("auth.signIn") }}
          </button>
        </form>
      </div>
      <AlertMessage color="is-danger" :message="errorMessage"></AlertMessage>
      <p class="has-text-grey">
        <router-link :to="{ name: 'authForgotPassword' }">
          {{ $t("auth.forgotPassword") }}
        </router-link>
      </p>
      <p class="has-text-grey mt-6">
        <a href="/help/index.html" target="_blank">
          {{ $t("Help") }}
        </a>
      </p>
      <p class="has-text-grey mt-6">
        <a @click="changeLocaleToJa">JP</a> &nbsp;|&nbsp;
        <a @click="changeLocaleToEn">EN</a>
      </p>
    </div>
  </div>
</template>

<script>
import AlertMessage from "@/components/AlertMessage.vue";
import FlashMessage from "@/components/FlashMessage.vue";
import imsr from "@/imsr-api";
import { Auth } from "aws-amplify";
import { reactive, ref } from "vue";
import { useI18n } from "vue-i18n";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";

export default {
  components: {
    FlashMessage,
    AlertMessage,
  },
  setup() {
    const { t, locale } = useI18n();
    const store = useStore();
    const route = useRoute();
    const router = useRouter();
    const errorMessage = ref();
    const isLoad = ref(false);
    const isCode = ref(false);
    const form = reactive({
      email: "",
      password: "",
      space: "",
      userCode: "",
    });

    const signIn = async () => {
      try {
        isLoad.value = true;
        const signin = await Auth.signIn(form.email, form.password);
        if (
          signin.challengeName === "SOFTWARE_TOKEN_MFA" &&
          isCode.value === false
        ) {
          isCode.value = true;
          isLoad.value = false;
          return true;
        } else if (
          signin.challengeName === "SOFTWARE_TOKEN_MFA" &&
          isCode.value === true
        ) {
          await Auth.confirmSignIn(signin, form.userCode, "SOFTWARE_TOKEN_MFA");
        }
        const params = {
          tenantId: form.space,
        };
        const imsr_user = await imsr.imsrGetApi("/users", params);
        await imsr.imsrPutApi("/users/lastLogin", params);
        store.commit("setUserId", imsr_user.userId);
        store.commit("setUserRole", imsr_user.userRole);
        store.commit("setTenantId", imsr_user.tenantId);
        store.commit("setLocale", imsr_user.lang);
        // store.commit(
        //   "setZoneinfo",
        //   imsr_user.zoneinfo ? imsr_user.zoneinfo : 9
        // );
        locale.value = imsr_user.lang;
        if (imsr_user.lastProject != "") {
          const params2 = {
            tenantId: imsr_user.tenantId,
            projectId: imsr_user.lastProject,
          };
          try {
            const project = await imsr.imsrGetApi("/projects/user", params2);
            if (imsr_user.lastProject != "") {
              store.commit("setProjectId", imsr_user.lastProject);
              store.commit("setProjectName", project.projectName);
              store.commit("setProjectRole", project.userRole);
              store.commit("setTimezone", project.timezone);
              store.commit("setZoneinfo", project.zoneinfo);
              if (route.query.redirect) {
                router.push({ path: route.query.redirect, replace: true });
              } else {
                router.push({
                  name: "dashboard",
                  params: { projectId: imsr_user.lastProject },
                  replace: true,
                });
              }
            }
          } catch {
            router.push({
              name: "projectsList",
              replace: true,
            });
          }
        } else {
          router.push({
            name: "projectsList",
            replace: true,
          });
        }
      } catch (e) {
        await Auth.signOut();
        if (e.code == "NotAuthorizedException") {
          errorMessage.value = t("auth.errorUsernamePassword");
        } else if (e.message == "bad request.") {
          errorMessage.value = t("auth.errorUsernamePassword");
        } else if (e.code == "CodeMismatchException") {
          errorMessage.value = t("auth.errorUserCode");
        } else {
          errorMessage.value = t("auth.authError");
        }
      }
      isLoad.value = false;
    };

    const changeLocaleToJa = () => {
      locale.value = "ja";
      store.commit("setLocale", "ja");
    };
    const changeLocaleToEn = () => {
      locale.value = "en-US";
      store.commit("setLocale", "en-US");
    };

    return {
      form,
      errorMessage,
      isLoad,
      signIn,
      isCode,
      changeLocaleToJa,
      changeLocaleToEn,
    };
  },
};
</script>
